import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({
    children,
    requiredUserType = null,
    requireAuth = true,
    redirectTo = '/signin',
}) => {
    const { isAuthenticated, userData, loading } = useAuth();

    if (loading) {
        return (
        <div style={{ textAlign: 'center', padding: '2rem' }}>
            Cargando…
        </div>
        );
    }

    if (requireAuth && !isAuthenticated) {
        return <Navigate to={redirectTo} replace />;
    }

    if (
        requiredUserType !== null &&
        requiredUserType !== undefined &&
        userData?.tipo !== requiredUserType
    ) {
        return <Navigate to='/' replace />;
    }

    return children;
};

export default ProtectedRoute;
